import React from "react";

export const CustomCRMItemRowEntry = (props) => {
    const {
        columnID,
        columns,
        state,
        setStateWithUpdate,
        handleOnFocus,
        handleBlur
    } = props

    const columnName = columns[columnID]["name"]
    const value = state.column_entries[columnID]?.value || ""

    return (
        <td className={'LeadItem-td'} key={columnID}>
            <input
                onFocus={handleOnFocus}
                onBlur={handleBlur}
                type="text"
                onChange={(e) => {
                    setStateWithUpdate(
                        {
                            ...state,
                            column_entries: {
                                ...state.column_entries,
                                [columnID]: {value: e.target.value, name: columnName}
                            }
                        })
                }}
                value={value}
            />
        </td>
    )
}